// Sugalarm — Cycle 451.5: the Log's field checks, shared.
//
// The manual Carbs field (LogScreen) and the Bolus units step
// (InsulinFlow) each validated inline. The meal-photo bolus handoff must
// accept exactly what a hand entry would, so both checks live here and all
// three callers use the same functions. Behaviour is unchanged.

/** The manual Carbs field's message (unchanged copy). */
export const CARBS_INVALID_MESSAGE = "Enter carbs in grams (0 is OK).";

/** The manual Carbs field's check: grams, 0 allowed. Null when invalid. */
export function parseCarbGrams(value: string): number | null {
  const n = Number(value);
  if (value === "" || !Number.isFinite(n) || n < 0) return null;
  return n;
}

/** Cycle 453.4 (operator decision) — the meal bolus's OPTIONAL Carbs field.
 *  Empty or whitespace is "not entered" (null: the save omits `carbs_g`);
 *  anything else goes through the manual Carbs field's own check, so a typed
 *  0 is an entered 0. Trimmed first because `parseCarbGrams("  ")` reads 0.
 *  An invalid non-empty value is null too — omitted, exactly as before. */
export function parseOptionalCarbGrams(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  return parseCarbGrams(trimmed);
}

/** The Bolus units step's check: a positive number. Null when invalid. */
export function parseInsulinUnits(value: string): number | null {
  const u = Number(value);
  if (!Number.isFinite(u) || u <= 0) return null;
  return u;
}
